package com.milta.feature.importjobs.domain.entity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ImportJobStatus {
    @SerialName("Pending") PENDING,
    @SerialName("Processing") PROCESSING,
    @SerialName("Success") SUCCESS,
    @SerialName("PartialSuccess") PARTIAL_SUCCESS,
    @SerialName("Failed") FAILED,
    @SerialName("Cancelled") CANCELLED;

    /** Still being worked on server-side: the tracker keeps polling these. */
    val isInProgress: Boolean get() = this == PENDING || this == PROCESSING

    /** A result is available (`result` is present) and waits to be validated by the user. */
    val hasResult: Boolean get() = this == SUCCESS || this == PARTIAL_SUCCESS
}
